import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  public impersonatedUser: any = null;

  constructor(private authService: AuthService) { }

  ngOnInit() {
  }

  isImpersonating() {
    this.impersonatedUser = this.authService.getImpersonatedUser();
    return this.impersonatedUser;
  }

}
